<mat-sidenav-container>
  <mat-sidenav *ngIf="showTemplate" #sidenav mode="push" class="sidenav" fixedInViewport="true"
    (closedStart)="onSidenavClosedStart()" (openedStart)="onSidenavOpenedStart()">
    <div class="mobile-menu-wrapper">
      <web-menu-mobile></web-menu-mobile>
    </div>
  </mat-sidenav>

  <mat-sidenav-content [class.template-content-hidden]="!showContent">
    <web-header *ngIf="showTemplate"></web-header>
    <web-breadcrumb *ngIf="showTemplate && showBreadcrumb"></web-breadcrumb>

    <!-- Container -->
    <div class="container general-structure">
      <div class="loading" *ngIf="sharedService.loading">
        <mat-spinner [diameter]="32" [strokeWidth]="4"></mat-spinner>
      </div>
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </div>

    <web-footer *ngIf="showTemplate"></web-footer>
  </mat-sidenav-content>
</mat-sidenav-container>

<web-project-cookies-consent [showCookiesInfo]="showCookiesInfo" (acceptCookies)="showCookiesInfo=false"
  (openCookiesPolicy)="openCookiesPolicy()"></web-project-cookies-consent>

<div #addThisScriptContainer></div>

<div id="chat-container" class="chat-container" *ngIf="showTemplate">
  <web-chat></web-chat>
</div>
